/* PDP price <-> Kaching selected-bar sync. Moved out of snippets/pdp-price.liquid (inline) 2026-09-29. */
(function () {
  if (window.__mmPdpPriceWired) return;
  window.__mmPdpPriceWired = true;

  function clean(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function cents(text) {
    if (!text) return null;
    var f = parseFloat(String(text).replace(/[^0-9.,]/g, '').replace(/,/g, ''));
    return isNaN(f) ? null : Math.round(f * 100);
  }
  // Parity with Liquid money_without_trailing_zeros: "$6" / "$6.01"
  function money(c) { var v = c / 100; return '$' + (c % 100 === 0 ? v : v.toFixed(2)); }
  // Same rule as the server render: savings snap to the nearest $5 step
  // ($84.99 → $85); under $5 the exact amount stays so it can't read $0.
  function saveRound(c) { return c >= 500 ? Math.round(c / 500) * 500 : c; }

  function sync() {
    var els = document.querySelectorAll('[data-mm-price][data-mm-price-sync]');
    var inst = document.querySelectorAll('[data-mm-inst]'); // installments block: amount = deal price ÷ count
    if (!els.length && !inst.length) return;

    // Only the discounted "today" amount lives in __bar-price; the struck
    // compare is the separate __bar-full-price sibling (never two numbers).
    var bar = document.querySelector('.kaching-bundles__bar--selected');
    if (!bar) return; // no widget on this PDP (or not rendered yet) → server prices stay
    var now = clean(bar.querySelector('.kaching-bundles__bar-price'));
    var nowC = cents(now);
    if (!now || nowC == null || nowC <= 0) return; // mid-render → don't touch
    var was = clean(bar.querySelector('.kaching-bundles__bar-full-price'));
    var wasC = cents(was);
    if (wasC == null || wasC <= nowC) { was = ''; wasC = null; } // never a fake markdown
    // Re-write the copied bar text in the theme's price format (cents / rounded / floored)
    if (window.mmMoney) { now = window.mmMoney(nowC); if (was) was = window.mmMoney(wasC); }

    for (var i = 0; i < els.length; i++) {
      try {
        var el = els[i];
        var nowEl = el.querySelector('[data-mm-price-now]');
        var wasEl = el.querySelector('[data-mm-price-was]');
        var saveEl = el.querySelector('[data-mm-price-save]');
        if (nowEl && nowEl.textContent !== now) nowEl.textContent = now;
        if (wasEl) {
          if (was && wasEl.textContent !== was) wasEl.textContent = was;
          wasEl.hidden = !was;
        }
        if (saveEl) {
          var style = el.getAttribute('data-save-style');
          var txt = '';
          if (was && style === 'percent') txt = 'SAVE ' + Math.round((wasC - nowC) * 100 / wasC) + '%';
          else if (was && style === 'amount') txt = 'SAVE ' + money(saveRound(wasC - nowC));
          if (txt && saveEl.textContent !== txt) saveEl.textContent = txt;
          saveEl.hidden = !txt;
        }
      } catch (e) { /* one bad element must not stop the rest */ }
    }

    // Installment amount always keeps its cents — it's what the provider charges
    for (var j = 0; j < inst.length; j++) {
      var n = parseInt(inst[j].getAttribute('data-mm-inst'), 10) || 4;
      var amt = '$' + (Math.round(nowC / n) / 100).toFixed(2);
      var amtEls = inst[j].querySelectorAll('[data-mm-inst-amt]');
      for (var k = 0; k < amtEls.length; k++) {
        if (amtEls[k].textContent !== amt) amtEls[k].textContent = amt;
      }
    }
  }

  var rafPending = false;
  function schedule() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () { rafPending = false; try { sync(); } catch (e) {} });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  // The widget renders/re-renders client-side and toggles --selected /
  // data-selling-plan-id (same hooks pdp-bundle-sub-footer watches). Our
  // own equality-guarded writes converge instead of looping.
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-selling-plan-id']
    });
  }
})();
